import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from 'vue'
import { useGameStore } from '../../store/useGameStore'
import { useAppStore } from '@/store/useAppStore'
import { AgGridVue } from 'ag-grid-vue3'
import { GridOptions } from 'ag-grid-enterprise'
import { CellEvent } from 'ag-grid-community'
import { baseUrl } from '@/constants'
// Class
import { TrackingDetails, TrackingDetailsTableLayout } from '../../types/main'


export default /*#__PURE__*/_defineComponent({
  __name: 'MonitorLogs',
  setup(__props, { expose }) {
  expose();

const { actions: gameActions, getters: gameGetters } = useGameStore()
const selectedTracking: Ref<TrackingDetails | undefined> = ref(undefined)
const gridOptions: GridOptions = {
  columnDefs: TrackingDetails.columnDefs(),
  suppressScrollOnNewData: true,
  stopEditingWhenCellsLoseFocus: true,
  statusBar: {
    statusPanels: [
      {
        statusPanel: 'agFilteredRowCountComponent',
        align: 'center',
      },
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
    ],
  },
  sideBar: true,
  enableRangeSelection: true,
}

const trackingTableFilterText = ref('')
const rowData: Ref<TrackingDetailsTableLayout[]> = ref([])

const getData = async () => {
  useAppStore().actions.setLoading(true)
  await gameActions.getAllTrackingDetails()
  rowData.value = gameGetters.allTrackings.value.map((tt) => tt.asTableData)
}
getData()

//Table Filter
// Filter all columns based on the text
// If one of the columns contain the text, the table will show them
const onTableSearchTextChanged = () => {
  gridOptions.api?.setQuickFilter(trackingTableFilterText.value)
}
const dataReady = () => {
  useAppStore().actions.setLoading(false)
}
// Handle Table Events
const cellClicked = (event: CellEvent) => {
  if (event.data === undefined) return
  const tracking = gameGetters.allTrackings.value.find((t) => t.oid == event.data.oid)
  selectedTracking.value = tracking
}

const __returned__ = { gameActions, gameGetters, selectedTracking, gridOptions, trackingTableFilterText, rowData, getData, onTableSearchTextChanged, dataReady, cellClicked, AgGridVue, baseUrl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})